import { store } from '@/store';

import { baConfig } from '../../config';

/**
 * When the 'multi-cluster-routing' feature flag is enabled, swaps us-1-specific
 * base URLs to baConfig.apiUrl (which routes via api-gateway to the correct cluster).
 * Otherwise returns the original URL unchanged.
 *
 * TODO: Once api-gateway routing is live for all clusters, remove this helper
 * and replace all call sites with baConfig.apiUrl.
 */
export function getClusterAwareBaseUrl(us1Url: string): string {
  const features = store.getters.features;
  if (features?.['multi-cluster-routing'] === 'true') {
    return baConfig.apiUrl ?? us1Url;
  }
  return us1Url;
}
